/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars*/
import { Grid, TextField, Typography, Button } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { dateConfig } from "config";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getProjectDetailsByCountry } from "redux/actions/appActions";
import { getWorkersByMgr } from "services";
import { getLocationForCountry } from "services/bulkUpload";
import { getProjectsByCountry } from "services/index";
import { getEndOfWeek } from "utils";
import WeekPicker from "../../Review/components/WeekPicker";
import { getWeekError, recordFormat } from "./utils";
import FormControl from "@material-ui/core/FormControl";
import {
  getWorkerIMTimeRole,
  getWorkerSchedule
} from "services/workerSchedule";
import { ITContractor, SPACE } from "config/CONSTANTS";
import {fetchTotalHoursOfWorker} from 'services/timesheet';
import {jobTypeITContractor} from '../../../utils'
import { endOfWeek } from "date-fns";
import { getWorkerPunchRecords } from "services";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    width: 'max-content'
  },
  formControl: {
    minWidth: "250px",
  },
  selectedWorker: {
    backgroundColor: theme.palette.action.selected,
    textAlign: "center",
    padding: theme.spacing(1.25),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.main,
  },
}));

const DropDowns = (props) => {
  const {
    onChangeSelections,
    reset,
    setLoading,
    index,
    register,
    control,
    onUpdate,
    setValue,
    trigger,
    errors,
    getValues,
    locationProps,
    setWorkerShedule,
    onPunchRowUpdate,
    setOldData,
    initialRecord,
    initialTotalsObj,
    handleAdd,
    jobProjectOptions=[],
    handleAddProject,
    fields=[]
  } = props;

  const classes = useStyles();

  const { t } = useTranslation();
  const { user, isAuthenticated } = useSelector((state) => state.user.auth);
  const { selectedWeekOnReview, deviceCountry } = useSelector(
    (state) => state.appConfig
  );
  const { selectedManagerForApproval } = useSelector(
    (state) => state.appConfig
  );
  const projectDropdownOptions = jobProjectOptions.filter(jobProject => !fields.map(field => field?.details).includes(jobProject));

  const [workers, setWorkers] = useState([]);
  const [imtRole, setImtRole] = useState("");
  const [week, setWeek] = React.useState( moment().startOf("week").format(dateConfig.format6));
  const [selectedWorker, setSelectedWorker] = useState("");
  const [selectedProject, setSelectedProject] = useState("");

  const isManager = isAuthenticated && user && user.isApprover && user.isActiveWorker;
  console.log('isManager', isManager);
  const dispatch = useDispatch();
  const customerSiteLabel = t("pgPunch.phCustomerSite") + "*";
  useEffect(() => {
    // Get all My Workers
    if (locationProps && locationProps.worker) {
      register("selectedWorker");
      setValue("selectedWorker", locationProps.worker);
      setSelectedWorker(locationProps.worker);
    }
    if (user && user.workerId && isManager) {
      if (locationProps && locationProps.worker) {
        register("selectedWorker");
        setValue("selectedWorker", locationProps.worker);
        setSelectedWorker(locationProps.worker);
      }
      console.log("trell", locationProps, user);
      let userWorkerId = user.workerId;
      setLoading(true);
      //show the selected worker on timesheet page
      if (locationProps && locationProps.worker && locationProps.worker.workerId 
        && locationProps.worker.workerId !== user.workerId) {
        userWorkerId = locationProps.worker.managerId;
      }
      //from all selection
      if (locationProps && locationProps.workers && locationProps.workers.length != 0) {
        userWorkerId = locationProps.workers[0].managerId;
      }
      if (
        locationProps &&
        locationProps.workers &&
        locationProps.workers.length == 0
      ) {
        userWorkerId = selectedManagerForApproval;
      }

      getWorkerIMTimeRole(user.workerId).then((logindata) => {
          setImtRole(logindata.role);
          getWorkersByMgr(userWorkerId)
            .then((data) => {
              console.log(`getWorkersByMgr for ${ userWorkerId} = data=`, data);
              let active = [];
              if(user && user.jobType && user.jobType === jobTypeITContractor && user.managerId && userWorkerId !== user.managerId){
                let loggedInUser = {...user, name:user.firstName+SPACE+user.lastName}
                active.push(loggedInUser);
              }
              //When user directly navigates to add-timesheet, it should render, if data exists then show that otherwise empty options in worker
              if (data !== false) {
                for (let i = 0; i < data.workers.length; i++) {
                  if (data.workers[i].isActiveWorker && data.workers[i].jobType && data.workers[i].jobType == jobTypeITContractor) {
                    active.push(data.workers[i]);
                  }
                }
              }
              //sorting the workers name in workers dropdown
              active.sort((a, b) =>
                a.name.toLowerCase() > b.name.toLowerCase()
                  ? 1
                  : a.name.toLowerCase() === b.name.toLowerCase()
                  ? a.workerId > b.workerId
                    ? 1
                    : -1
                  : -1
              );
              let delegateFor = user?.delegateFor;
              if ((!(delegateFor && userWorkerId &&
                delegateFor.includes(userWorkerId))) &&
                ((logindata.role && logindata.role !== "" && logindata.role.toLowerCase() === "supervisor" && user.workerId !== userWorkerId)
                  || (!logindata.role && user && user.isApprover && user.workerId !== userWorkerId))) {

                active = active.length > 0 && active.filter(item => item.approvingManager && item.approvingManager.includes(user.workerId))
              }
              setWorkers(active);
              setLoading(false);
            })
      })
        .catch((err) => {
          // setLoading(false);
          console.error("BulkEntry: Err in getWorkerByMgr Response: ", err);
        });
    }
    trigger();
  }, [user]);

  useEffect(() => {
    console.log("check435", selectedWorker, week);
    if (selectedWorker && selectedWorker.workerId && week) {
      setLoading(true);
      reset();
      register('selectedWorker');
      setValue('selectedWorker', selectedWorker);
      if(selectedWorker.timezone && Object.keys(selectedWorker.timezone).length>0){
        getWorkerSchedule(selectedWorker.workerId).then((data)=>{
           console.log("device worker", data);
           setWorkerShedule(data);
           setLoading(false);
        }).catch((err)=>{
          //setLoading(false);
          console.log("BulkEntry: Err loading worker schedule data", err);
        });
       }
       const weekEnd = moment(week).endOf("week").add(1,'day').format(dateConfig.format6);
       getWorkerPunchRecords(selectedWorker.workerId, week, weekEnd).then((data=[]) =>{
      //  const { records = [] } = getValues();
        const records = [];
        const projectDetailsMap = {};
        // if(records && records.length >0){
        //   records.map((projectDetails, ind) =>{
        //     if(projectDetails.details)
        //     projectDetailsMap [projectDetails.details] = ind;
        //   })
        // }
        if(data && data.length > 0){
          data.forEach(punch =>{
            const punchDuration = punch.duration;
            const outTime = punch.inLocalTS;
            const details = punch.jobProjectInfo;
            const dayIndex = outTime ? moment(outTime).day():-1;
            const comment = punch?.projectDetails || "";
            if(!projectDetailsMap.hasOwnProperty(details)){
              projectDetailsMap[details] = records.length;
              records.push({...recordFormat, details})
            }
            if(punch.jobType === ITContractor && punchDuration && Math.abs(punchDuration) >0 
              && dayIndex>=0 && details){
              let recordIndex = projectDetailsMap[details];
              if(recordIndex >=0){
                let curValue = records[recordIndex][`day${dayIndex+1}`];
                records[recordIndex][`day${dayIndex+1}`] = parseFloat(curValue ? curValue : "0") + parseFloat(punchDuration ? punchDuration : "0")
                records[recordIndex].projectDetails = comment;
              }
            }
          })
          setOldData({records:records});
          handleAdd(records);
          console.log('worker timesheet', data, records);
          onUpdate();
        }else{
        //   reset();
           register('selectedWorker');
           setValue('selectedWorker', selectedWorker);
           setOldData({records:initialRecord, weekTotal: initialTotalsObj});
        }
        trigger();
        setLoading(false);
      }).catch(err =>{
        console.log('fetchTotalHoursOfWorker error', err);
        setLoading(false);
      })
        }
  }, [selectedWorker, week]);


  const weekChangeHandler = (date) => {
    const weekStart = moment(date).format(dateConfig.format6);
    const weekEnd = moment(date).endOf("week").format(dateConfig.format6);
    setWeek(weekStart);
    setValue("weekStart", weekStart);
    setValue("weekPicker", weekStart);
    setValue("weekEnd", weekEnd);
    onUpdate();
  };

  useEffect(() => {
    const weekStart = moment(week).format(dateConfig.format6);
    const weekEnd = moment(week).endOf("week").format(dateConfig.format6);
    console.log("weekEnd",weekStart, weekEnd);
    setWeek(weekStart);
    setValue("weekStart", weekStart);
    setValue("weekPicker", weekStart);
    setValue("weekEnd", weekEnd);
    onChangeSelections({
      weekStart: week,
      weekEnd,
      selectedWorker,
    });
  }, [week, selectedWorker]);

  useEffect(() => {
    const weekStart = moment().startOf("week").format(dateConfig.format6);
    const weekEnd = moment().endOf("week").format(dateConfig.format6);
    register('selectedWorker');
    register("weekStart");
    register("weekEnd");
    setValue("weekStart", weekStart);
    setValue("weekEnd", weekEnd);
  }, []);

  return (
    <Grid container className={classes.root} spacing={2} alignItems="center">
      <Grid item>
        {/* <WeekPicker lbl={"Select Week"} weekChangeHandler={weekChangeHandler} /> */}
        <Controller
          name="weekPicker"
          control={control}
          render={({ onChange, value }) => (
            <WeekPicker
              variant = 'outlined'
              lbl={t("other.timeSheetWeekSelector")}
              selected={value}
              // startDate={week}
              weekChangeHandler={weekChangeHandler}
              maxDate={moment().endOf("week")}
              minDate={moment().subtract(2, "weeks")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                />
              )}
            />
          )}
        />
      </Grid>
      <Grid item>
      { isManager && <Controller
          render={(props) => (
            <Autocomplete
              size="small"
              className={classes.formControl}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              fullWidth
              //disableClearable
              value={selectedWorker}
              defaultValue={{ value: selectedWorker }}
              options={workers}
              getOptionLabel={(option) =>
                option.name ? option.name + " (" + option.workerId + ")" : ""
              }
              getOptionSelected={(option, value) =>option && option.workerId && value 
                && value.workerId && option.workerId === value.workerId
              }
              renderInput={(params) => (
                <TextField
                  label={t("other.timeSheetWorkerDropdown")}
                  size="small"
                  variant="outlined"
                  {...params}
                  {...props}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  placeholder={t("other.timeSheetWorkerDropdown")}
                  error={getWeekError(errors, "selectedWorker")}
                />
              )}
              onInputChange={(event, newValue) => {
                if (!newValue) {
                  // setWorkers([]);
                  props.onChange(newValue);
                  setSelectedWorker("");
                  reset();
                }
              }}
              onChange={(event, newValue) => {
                props.onChange(newValue);
                if (newValue) {
                  setWorkerShedule({});
                  reset();
                    setSelectedWorker(newValue);
                  onUpdate(index, -1);
                }
              }}
            />
          )}
          name="selectedWorker"
          control={control}
          //defaultValue={selectedWorker}
        /> 
        }
        </Grid>
          <Grid item>
          {selectedWorker && selectedWorker.workerId && (
            <Typography variant="subtitle" className={classes.selectedWorker}>
              {selectedWorker.firstName + SPACE + selectedWorker.lastName}({selectedWorker.workerId})
            </Typography>
          )}   
      </Grid>
       <Grid item style={{display: 'flex', columnGap: '10px'}}>
            <Autocomplete
              size="small"
              className={classes.formControl}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              fullWidth
              //disableClearable
              value={selectedProject}
              options={projectDropdownOptions}
              renderInput={(params) => (
                <TextField
                  label={t("other.selectProject")}
                  size="small"
                  variant="outlined"
                  {...params}
                  {...props}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  placeholder={t("other.selectProject")}
                />
              )}
              onChange={(event, newValue) => {
              setSelectedProject(newValue);
              }}
            />
            <Button
              color="primary"
              variant="contained"
              disabled={!selectedProject}
              onClick={() => {
                if(selectedProject)
                handleAddProject({...recordFormat, details: selectedProject});
                setSelectedProject("");
              }}
            >
              {t("other.timeSheetAdd")}
            </Button>
        </Grid>
    </Grid>
  );
};

DropDowns.propTypes = {
  onChangeSelections: PropTypes.func,
  setLoading: PropTypes.func,
  loading: PropTypes.bool,
  onUpdate: PropTypes.func,
};

export default DropDowns;
